import style from '../../sass/style.module.scss';
// import PdfContentContainer from './PdfContentContainer';
import { fontSemiBold, text2xl, text2xlLineHeight } from './styleConstants';

export default function QuotePdfHeader({ xMargins }) {
  const overviewImage = '';

  const headerBgStyle = overviewImage
    ? {
        backgroundImage: `url(${overviewImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'right top',
      }
    : {};

  const headerClassNames = overviewImage ? '' : style.overviewPageHeader;

  return (
    <header
      style={{
        ...headerBgStyle,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '400px',
      }}
      className={headerClassNames}
    >
      <div
        style={{
          paddingBottom: '1.75rem',
          color: '#fff',
          height: '100%',
          display: 'flex',
          alignItems: 'flex-end',
          background:
            'linear-gradient(0deg, rgba(0, 0, 0, 0.4570203081) 18%, rgba(255, 255, 255, 0) 100%)',
        }}
      >
        <div style={{ ...xMargins }}>
          <p style={{ fontSize: text2xl, textAlign: text2xlLineHeight }}>
            Your holiday to
          </p>
          <div style={{ fontWeight: fontSemiBold, fontSize: '75px' }}>
            <p style={{ marginRight: '.5rem', marginBottom: '1rem' }}>
              Imperial Plaza
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
